type StepVariant = "purple" | "gray" | "white";

interface StepSectionProps {
  step: number;
  title: string;
  paragraph: string;
  image?: string;
  variant: StepVariant;
  className?: string;
}

const variantStyles: Record<
  StepVariant,
  { bg: string; title: string; paragraph: string; badge: string }
> = {
  purple: {
    bg: "bg-gradient-to-br from-[#7062ff] to-[#5f00cb]",
    title: "text-white",
    paragraph: "text-white/80",
    badge: "bg-white text-indigo-600",
  },
  gray: {
    bg: "bg-gray-50",
    title: "text-gray-900",
    paragraph: "text-stone-500",
    badge: "bg-indigo-600 text-white",
  },
  white: {
    bg: "bg-white",
    title: "text-gray-900",
    paragraph: "text-stone-500",
    badge: "bg-indigo-600 text-white",
  },
};

export const StepSection = ({
  step,
  title,
  paragraph,
  image,
  variant,
  className,
}: StepSectionProps) => {
  const styles = variantStyles[variant];

  return (
    <div
      className={`relative overflow-visible w-full py-4 md:py-8 ${styles.bg} ${
        image ? "z-10" : "z-0"
      } ${className ? className : ""}`}
    >
      <div className="max-w-3xl relative mx-auto px-6 py-10 flex flex-col md:flex-row items-center md:items-stretch gap-4 min-h-[11rem]">
        <div className="flex gap-3 max-w-sm w-full">
          {/* Step number */}
          <span
            className={`h-12 w-12 flex-shrink-0 rounded-full flex justify-center items-center text-3xl font-bold ${styles.badge}`}
          >
            {step}
          </span>
          {/* Title and paragraph */}
          <div className="flex flex-col gap-4 mt-2">
            <h3 className={`text-xl font-semibold ${styles.title}`}>{title}</h3>

            <p className={`text-sm md:text-base ${styles.paragraph}`}>
              {paragraph}
            </p>
          </div>
        </div>

        {image && (
          <img
            src={image}
            alt={`Step ${step}`}
            className={`w-auto max-h-[28rem] object-contain md:absolute md:top-0 md:right-0 md:h-[28rem] md:max-h-none ${step !== 1 ? "md:-mt-20" : ""}`}
          />
        )}
      </div>
    </div>
  );
};
